"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.overlap = exports.getOverlap = void 0;
const createApi_1 = require("../../helpers/createApi");
const getOverlap = (caller) => ({ accountId, page, prioritized, filters = {}, maxPerPage = 20 }) => {
    const query = {
        prioritized,
        _max_per_page: maxPerPage,
        _page: page,
        ...filters,
    };
    return caller(`/backend/accounts/${accountId}/overlap`).get(query);
};
exports.getOverlap = getOverlap;
exports.overlap = (0, createApi_1.createAPIFactory)({
    getOverlap: exports.getOverlap,
});
//# sourceMappingURL=api.js.map